import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
// 全局样式
import "./assets/css/global.less";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "element-plus/theme-chalk/dark/css-vars.css";

createApp(App).use(router).use(ElementPlus).mount("#app");
// 启用深色模式
document.documentElement.classList.add("dark");
